<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            :src="`${img_src}/${user.avatar}`"
            class="c-avatar-img "
          />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>{{user.name}}</strong>
    </CDropdownHeader>
    <CDropdownItem>
      <CIcon name="cil-user" /> Profile
    </CDropdownItem>
    <CDropdownItem>
      <CIcon name="cil-settings" /> Settings
    </CDropdownItem>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked"  /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
const ROOT_URL = process.env.VUE_APP_ROOT_URL
export default {
  name: 'TheHeaderDropdownAccnt',

  data () {
    return {
      itemsCount: 42,
      img_src: ROOT_URL,
      user: this.$store.getters['auth/authUser']
    }
  },
  methods: {
    logout(){
      this.$store.dispatch('auth/logout')
              .then(result => {
                window.location.href = '/login'
                console.log('logout :: ');
              })
              .catch(error => {
                console.log('logout failure :: ', error.response);
                window.location.href = '/login'
              })
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
